export type Module = {
  id: string
  name: string
  activeForClient: boolean
  description: string
}
export type SubModule = {
  id: string
  name: string
  description: string
  moduleId: string
  permissions: Permission[]
}
export type Permission = {
  id: string
  type: keyof typeof PermissionType
  name: string
  description: string
  subModuleId: string
}
export enum PermissionType {
  MODULE = 'MODULE',
  SPECIFIC = 'SPECIFIC',
  GENERAL = 'GENERAL'
}

export enum ModulePerms {
  USE = 'USE',
  JOB = 'JOB',
  RES = 'RES',
  PAR = 'PAR',
  FLA = 'FLA',
  ROU = 'ROU',
  MET = 'MET',
  ACC = 'ACC',
  SEG = 'SEG',
  ORA = 'ORA',
  ECO = 'ECO',
  ANA = 'ANA',
  LOG = 'LOG',
  SST = 'SST',
  COM = 'COM',
  WMS = 'WMS',
  CAL = 'CAL',
  JJS = 'JJS',
  TAS = 'TAS',
  PIC = 'PIC',
  MAR = 'MAR',
  GEN = 'GEN',
  INB = 'INB'
}
export enum SubModulePerms {
  JOB_GENERAL_CHANGE_ADDRESS = 'JOB_GENERAL_CHANGE_ADDRESS',
  JOB_GENERAL_MOVE_STORE = 'JOB_GENERAL_MOVE_STORE',
  JOB_GENERAL_RESCHEDULE = 'JOB_GENERAL_RESCHEDULE',
  JOB_GENERAL_CANCEL = 'JOB_GENERAL_CANCEL',
  JOB_GENERAL_INVOICE_EDIT = 'JOB_GENERAL_INVOICE_EDIT',
  JOB_GENERAL_INVOICE_UPLOAD = 'JOB_GENERAL_INVOICE_UPLOAD',
  JOB_GENERAL_ADDRESS = 'JOB_GENERAL_ADDRESS',
  JOB_GENERAL_CLIENT_INFO = 'JOB_GENERAL_CLIENT_INFO',
  JOB_GENERAL_EVENTS = 'JOB_GENERAL_EVENTS',
  JOB_GENERAL_ITEMS = 'JOB_GENERAL_ITEMS',
  JOB_GENERAL_HISTORY = 'JOB_GENERAL_HISTORY',
  JOB_GENERAL_MULTISTOP = 'JOB_GENERAL_MULTISTOP',
  JOB_GENERAL_UNLOCK = 'JOB_GENERAL_UNLOCK',
  JOB_TASK_REASIGN = 'JOB_TASK_REASIGN',
  JOB_TASK_RESTART = 'JOB_TASK_RESTART',
  JOB_TASK_FORCE_DELIVERY = 'JOB_TASK_FORCE_DELIVERY',
  JOB_TASK_UNLOCK = 'JOB_TASK_UNLOCK',
  JOB_CHAT_SEE = 'JOB_CHAT_SEE',
  FLA_GENERAL_ALL_SEE = 'FLA_GENERAL_ALL_SEE',
  MET_CAPACITY_SLOT_SWITCH = 'MET_CAPACITY_SLOT_SWITCH',
  USE_USER_GET_CLIENTS = 'USE_USER_GET_CLIENTS',
  USE_USER_CHANGE_CLIENT = 'USE_USER_CHANGE_CLIENT',
  RES_RESOURCE_QUOTA = 'RES_RESOURCE_QUOTA',
  RES_RESOURCE_SWITCH = 'RES_RESOURCE_SWITCH',
  PAR_GENERAL_SEE = 'PAR_GENERAL_SEE',
  PAR_REASON_SEE = 'PAR_REASON_SEE',
  PAR_LOGISTIC_SEE = 'PAR_LOGISTIC_SEE',
  PAR_SLOT_POLICY_SEE = 'PAR_SLOT_POLICY_SEE',
  PAR_API_CREDENTIALS_SEE = 'PAR_API_CREDENTIALS_SEE',
  FLA_GENERAL_AUTOMATIC_ASSIGN = 'FLA_GENERAL_AUTOMATIC_ASSIGN',
  MET_CAPACITY_STORE = 'MET_CAPACITY_STORE',
  MET_SUPPORT_LIVE = 'MET_SUPPORT_LIVE',
  MET_RESOURCES = 'MET_RESOURCES',
  RES_FLEET_MANAGER = 'RES_FLEET_MANAGER',
  RES_STORE_MANAGER = 'RES_STORE_MANAGER',
  USE_GROUP_SEE = 'USE_GROUP_SEE',
  USE_GROUP_CREATE = 'USE_GROUP_CREATE',
  USE_GROUP_UPDATE = 'USE_GROUP_UPDATE',
  USE_USER_SEE = 'USE_USER_SEE',
  USE_USER_CREATE = 'USE_USER_CREATE',
  USE_USER_UPDATE = 'USE_USER_UPDATE',
  USE_USER_DELETE = 'USE_USER_DELETE',
  USE_USER_RESET_PASSWORD = 'USE_USER_RESET_PASSWORD',
  USE_ROLE_SEE = 'USE_ROLE_SEE',
  USE_ROLE_CREATE = 'USE_ROLE_CREATE',
  USE_ROLE_UPDATE = 'USE_ROLE_UPDATE',
  RES_RESOURCE_SEE = 'RES_RESOURCE_SEE',
  RES_RESOURCE_CREATE = 'RES_RESOURCE_CREATE',
  RES_RESOURCE_UPDATE = 'RES_RESOURCE_UPDATE',
  RES_VEHICLE_SEE = 'RES_VEHICLE_SEE',
  RES_VEHICLE_CREATE = 'RES_VEHICLE_CREATE',
  RES_VEHICLE_UPDATE = 'RES_VEHICLE_UPDATE',
  ROU_ZONE_SEE = 'ROU_ZONE_SEE',
  MET_RESOURCES_PRODUCTIVITY = 'MET_RESOURCES_PRODUCTIVITY',
  MET_RESOURCES_PICKERS = 'MET_RESOURCES_PICKERS',
  MET_RESOURCES_DRIVERS = 'MET_RESOURCES_DRIVERS',
  GEN_NEWS_SEE = 'GEN_NEWS_SEE'
}
